import { Link } from "react-router-dom";

import { SHOW_PREVIEW_BADGE } from "@/lib/environment";
import { useI18n } from "@/i18n/I18nContext";
import { BrandLockup, V3Sidebar } from "./MemberLayout";
import { LoginAccessibilityMenu } from "./LoginAccessibilityMenu";
import { V3Title } from "./v3";

// V3 access frame (M01, M02, M29–M35): sidebar without navigation, no signed-in content.
export function PublicShell({ title, intro, children, testid, badge = true }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-v3-canvas text-v3-ink" data-testid={testid}>
      <a href="#member-main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-v3-magenta focus:px-4 focus:py-2 focus:text-white">
        {t("common.skip_to_content")}
      </a>
      <V3Sidebar />
      <div className="lg:pl-[238px]">
        <header className="sticky top-0 z-20 border-b border-v3-line bg-white">
          <div className="hidden h-[82px] items-center gap-[24px] pl-[33px] pr-[122px] lg:flex">
            <p className="flex-1 text-[17px] font-bold text-v3-ink">Mitglieder-App</p>
            <LoginAccessibilityMenu />
            <p className="text-[14px] text-v3-muted" data-testid="public-topbar-access">Persönlicher Zugang</p>
          </div>
          <div className="flex h-[76px] items-center gap-3 px-[17px] lg:hidden">
            <Link to="/login" aria-label="VISIBILIS.LIFE – zur Anmeldung" className="flex-1"><BrandLockup /></Link>
            <LoginAccessibilityMenu />
          </div>
        </header>
        <main id="member-main" tabIndex={-1} className="mx-auto max-w-[1210px] px-5 pb-12 pt-[20px] outline-none lg:pl-[38px] lg:pr-[40px] lg:pt-[25px]">
          <p className="mb-[18px] hidden text-[12px] font-bold leading-[18px] text-v3-muted lg:block" data-testid="public-breadcrumb">Entdecken / Mein Bereich</p>
          <V3Title title={title} intro={intro} testid="public-title" />
          {children}
          {badge && SHOW_PREVIEW_BADGE && <p className="mt-8 text-[12px] font-bold uppercase tracking-wide text-v3-muted lg:hidden" data-testid="public-preview-badge">{t("member.login.preview_badge")}</p>}
        </main>
      </div>
    </div>
  );
}
